import { Box, Flex, Heading } from '@chakra-ui/react';
import { ArrowRightIcon } from '@udacity/chakra-uds-icons';

import { ButtonLink } from '~/components/button-link';
import { Card } from '~/components/card';
import { ContentContainer } from '~/components/container';
import { trackEvent } from '~/features/analytics/track-event';
import { useCatalogPath } from '~/hooks/use-catalog-path';

export type OtherSchoolsSectionProps = {
  title: string;
  schools: Array<{
    title: string;
    href: string;
  }>;
};

export function OtherSchoolsSection({ title, schools }: OtherSchoolsSectionProps) {
  const catalogPath = useCatalogPath();
  if (!schools?.length) return null;
  return (
    <Box as='section'>
      <ContentContainer
        marginY={{
          md: '64px',
        }}
      >
        <Card
          backgroundColor='white'
          marginY={{
            base: '24px',
            md: '64px',
          }}
          padding={{
            base: '40px 16px',
            md: '40px',
          }}
        >
          <Heading as='h2' size='h2'>
            {title}
          </Heading>
          <Box height='16px' />
          <Flex
            flexWrap='wrap'
            gap='16px'
            justifyContent={{
              base: 'center',
              md: 'unset',
            }}
          >
            {schools.map((school) => (
              <ButtonLink
                key={school.title}
                buttonProps={{
                  variant: 'outline',
                  size: 'icon-right',
                  rightIcon: <ArrowRightIcon height='24px' width='24px' />,
                  whiteSpace: 'nowrap',
                  padding: '12px 16px 12px 30px',
                  width: {
                    base: '100%',
                    md: 'min-content',
                  },
                  onClick: () =>
                    trackEvent({
                      type: 'click',
                      name: 'Schools Page CTA Clicked',
                      label: school.title,
                    }),
                }}
                linkProps={{
                  href: school.href,
                }}
              >
                {school.title}
              </ButtonLink>
            ))}
            <ButtonLink
              key='catalog'
              buttonProps={{
                variant: 'link',
                whiteSpace: 'nowrap',
                padding: '12px 24px',
              }}
              linkProps={{
                href: catalogPath,
              }}
            >
              View Full Catalog
            </ButtonLink>
          </Flex>
        </Card>
      </ContentContainer>
    </Box>
  );
}
